import { render, staticRenderFns } from "./CombinedResultAchievementReportWidget.vue?vue&type=template&id=4070082d"
import script from "./CombinedResultAchievementReportWidget.vue?vue&type=script&lang=js"
export * from "./CombinedResultAchievementReportWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports